import { regexTest, stringCompare, TableDataConfig } from "../../../core/table/TableDataConfig";
import { ProductBrandDto } from "../../../models/domain/enums";
import { UpdateGroupFarmDto } from "../../../models/domain/UpdateGroupFarmDto";

export const UpdateGroupFarmConfig: TableDataConfig<UpdateGroupFarmDto> = {
  farmId: {
    filterBy: value => obj => regexTest(value, obj.farmId),
    sortBy: (a, b) => stringCompare(a.farmId, b.farmId)
  },
  farmName: {
    filterBy: value => obj => regexTest(value, obj.farmName),
    sortBy: (a, b) => stringCompare(a.farmName, b.farmName)
  },
  ecoHerdVersion: {
    filterBy: value => obj => regexTest(value, obj.ecoHerdVersion),
    sortBy: (a, b) => stringCompare(a.ecoHerdVersion, b.ecoHerdVersion)
  },
  vendor: {
    filterBy: value => obj => regexTest(value, ProductBrandDto[obj.vendor]),
    sortBy: (a, b) => stringCompare(ProductBrandDto[a.vendor], ProductBrandDto[b.vendor])
  },
  updateGroupId: {
    filterBy: value => obj => regexTest(value, obj.updateGroup?.name ?? obj.productVersion?.name ?? "No info"),
    sortBy: (a, b) => stringCompare(a.updateGroup?.name ?? a.productVersion?.name, b.updateGroup?.name ?? b.productVersion?.name)
  }
}